"use strict";

angular.module("licensure.services").factory("EXLookupColumn", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamLookupColumns", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getenterpriselookupcolumns: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/EnterpriseExamLookupColumns", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (enterpriseExamLookup) {

                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamLookupColumns/";

                $http({
                    method: method,
                    url: url,
                    data: enterpriseExamLookup
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                });

                return d.promise;
            },

        };
    }
]);
